import React, { useState, useEffect } from 'react'
import { Row, Col, Input, Button as AntButton } from 'antd'
import { ButtonComponent as Button } from '../index'
import { maskCurrency, getContractTypeName } from '../../utils/functions'
import moment from 'moment'
import { SyncOutlined } from '@ant-design/icons'

const ApproveContract = (props) => {
    const { contract, handleModal, approve, error } = props
    const [quota, setQuota] = useState(0)
    const [exchangeRate, setExchangeRate] = useState(null)
    const [loadingRate, setLoadingRate] = useState(false)

    const fetchExchangeRate = async () => {
        setLoadingRate(true)
        try {
            const response = await fetch('https://api.exchangerate-api.com/v4/latest/USD')
            const data = await response.json()
            const rate = data.rates.BRL
            setExchangeRate(rate)
            setQuota(rate.toFixed(2))
        } catch (error) {
            console.error('Error fetching exchange rate:', error)
        }
        setLoadingRate(false)
    }

    useEffect(() => {
        fetchExchangeRate()
    }, [])

    const handleQuota = (e) => {
        setQuota(e.target.value)
    }

    const handleApprove = () => {
        // Parse quota to make sure it's a number
        const quotaValue = parseFloat(quota)
        if (isNaN(quotaValue) || quotaValue <= 0) {
            // Handle invalid input separately here if needed
            return
        }
        // Call the approve function with parsed value
        approve(contract.id, quotaValue, contract.valorInicial)
    }

    return (
        <>
        <Row>
            <Col md={20} className="d-flex align-center">
                <h1 className="font-bold font-28 tx-white">Aprovar contrato</h1>                
            </Col>
            <Col md={4} className="d-flex align-center justify-end">
                <label className="tx-white btn-close" onClick={handleModal}>Cancelar</label>
            </Col>
        </Row>
        <Row className="deny-info-wrapper d-flex align-items-center">
            <Col md={12} className="border">
                <Row>
                    <Col md={20}>
                        <h3 className="tx-pink font-bold">{contract.Cliente.nome}</h3>
                    </Col>
                    <Col md={4}>
                        <label className="tx-pink font-bold">{getContractTypeName(contract.tipoContrato)}</label><br />
                        <label className="tx-gray font-16">#{contract.id}</label>
                    </Col>
                    <Col md={24}>
                        <hr />
                    </Col>
                    <Col md={12} className="mt-10">
                        <label className="tx-pink font-bold">Solicitação</label><br />
                        <label className="tx-gray">{moment(contract.createdAt).format("DD/MM/YYYY")}</label>
                    </Col>
                    <Col md={24} className="mt-10">
                        <hr />
                    </Col>
                    <Col md={24} className="mt-10">
                        <label className="tx-pink font-bold">Valor</label><br />
                        <label className="tx-gray font-bold font-22">R$ {maskCurrency(contract.valorInicial)}</label>
                    </Col>
                </Row>
            </Col>
            <Col md={12} className="pl-20">
                <label className="tx-pink font-bold font-16">Valor da cotação</label>
                <div className="d-flex align-items-center">
                    <Input className="mt-15 bg-white" value={quota} onChange={handleQuota} type='number' />
                    <AntButton 
                        type="text" 
                        icon={<SyncOutlined spin={loadingRate} />} 
                        onClick={fetchExchangeRate}
                        className="ml-10"
                        title="Atualizar cotação"
                    />
                </div>
                {exchangeRate && (
                    <small className="tx-gray">
                        Cotação atual: R$ {exchangeRate.toFixed(2)}
                    </small>
                )}
                {error && <small className='tx-red'>A cotação deve ser maior que 0</small>}
                <Row className="mt-15">
                    <Col md={24}>
                        <Button type="success" active onClick={handleApprove}>Aprovar</Button>
                    </Col>
                </Row>
            </Col>
        </Row>
        </>
    )
}

export default ApproveContract